import React from 'react';

import { FilterMenuButton } from '@vlabs/monokit/shared/ui/filter-menu';

import type { TListListPageFilters } from './filters/types';
import { useListListPageFilters } from './useListListPageFilters';

function getActiveFiltersCount(filters: TListListPageFilters): number {
  const isCreateTimeSelected = filters.create_time__gte !== undefined || filters.create_time__lt !== undefined;
  const isLastUpdateTimeSelected = filters.last_update_time__gte !== undefined
    || filters.last_update_time__lt !== undefined;
  const restCount = [
    filters.user_data,
  ].filter((value) => value != null).length;

  return restCount + (isCreateTimeSelected ? 1 : 0) + (isLastUpdateTimeSelected ? 1 : 0);
}

function ListListPageFilterMenuButton(): React.JSX.Element {
  const { filters } = useListListPageFilters();

  return (
    <FilterMenuButton filtersCount={getActiveFiltersCount(filters)} />
  );
}

export { ListListPageFilterMenuButton };
